<template>
  <div class="register absolute modify-password" style="background:#fff;">
    <van-nav-bar
      :title="$t('m.modify_pwd_nav')"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="register_block section-block">
      <p class="section-title">{{ $t("m.dl_span21") }}</p>
      <div class="register_block_list">
        <input
          v-model="loginOld"
          type="password"
          :placeholder="$t('m.dl_span19')"
        />
      </div>
      <div class="register_block_list">
        <input
          v-model="loginNew"
          type="password"
          :placeholder="$t('m.dl_span20')"
        />
      </div>
      <div class="register_block_list">
        <input
          v-model="loginNew2"
          type="password"
          :placeholder="$t('m.dl_span18')"
        />
      </div>
      <van-button class="register_submit" @click="submitLogin">{{
        $t("m.tijiao")
      }}</van-button>
    </div>

    <div class="register_block section-block section-pay">
      <p class="section-title">{{ $t("m.dl_span22") }}</p>
      <div class="register_block_list">
        <input
          v-model="payOld"
          type="password"
          :placeholder="$t('m.dl_span19')"
        />
      </div>
      <div class="register_block_list">
        <input
          v-model="payNew"
          type="password"
          :placeholder="$t('m.dl_span20')"
        />
      </div>
      <div class="register_block_list">
        <input
          v-model="payNew2"
          type="password"
          :placeholder="$t('m.dl_span18')"
        />
      </div>
      <van-button class="register_submit" @click="submitPay">{{
        $t("m.tijiao")
      }}</van-button>
    </div>

    <div
      v-if="showOverlay"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;z-index: 999;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { loginPass, payPass } from "@api/user";

export default {
  name: "ModifyPassword",
  data() {
    return {
      showOverlay: false,
      loginOld: "",
      loginNew: "",
      loginNew2: "",
      payOld: "",
      payNew: "",
      payNew2: ""
    };
  },
  mounted() {
    request.get("/shop/sign/status", {}, { login: true });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    submitLogin() {
      const that = this;
      that.showOverlay = true;
      loginPass({
        old: that.loginOld,
        new: that.loginNew,
        new2: that.loginNew2
      })
        .then(() => {
          that.showOverlay = false;
          that.$dialog.success("密码修改成功").then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          that.showOverlay = false;
          that.$dialog.error(
            (res.response && res.response.data && res.response.data.msg) ||
              "修改失败"
          );
        });
    },
    submitPay() {
      const that = this;
      that.showOverlay = true;
      payPass({
        old: that.payOld,
        new: that.payNew,
        new1: that.payNew2
      })
        .then(() => {
          that.showOverlay = false;
          that.payOld = "";
          that.payNew = "";
          that.payNew2 = "";
          that.$dialog.success("密码修改成功");
        })
        .catch(res => {
          that.showOverlay = false;
          that.$dialog.error(
            (res.response && res.response.data && res.response.data.msg) ||
              "修改失败"
          );
        });
    }
  }
};
</script>

<style scoped lang="less">
/* 与全局 #footer 固定底栏 + 安全区留白，避免底部「提交」被挡住（底栏含图标+文案，略高于 1rem） */
.modify-password {
  box-sizing: border-box;
  min-height: 100vh;
  height: auto !important; /* 覆盖 .register 的 100vh，长表单可滚到底 */
  padding-bottom: calc(90px + env(safe-area-inset-bottom, 0px));
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.section-block {
  padding: 0 40px;
  margin-top: 20px;
}

.section-pay {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 8px solid #f5f5f5;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px;
}

.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 24px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}

.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 0px;
  display: flex;
  align-items: center;
  font-size: 14px;
  border-bottom: 1px solid #eee;
}

.register_block_list input {
  line-height: 50px;
  height: 50px;
  width: 100%;
  font-size: 15px;
}

/deep/ .van-nav-bar .van-icon {
  color: #333;
}
</style>
